<template>
	<div
		:class="{
			col: true,
			'col-xxl-10': true,
			'advanced-options': true,
			expanded: expandAdvancedOpts,
		}"
	>
		<button
			type="button"
			id="advSchemOpt"
			@click.prevent="userToggledAdvancedOpts = !expandAdvancedOpts"
			class="btn btn-box js-adv-options align-left"
			aria-expanded="false"
		>
			<span>Advanced Schematic Options</span>

			<i class="symbol"><svg aria-hidden="true">
				<use xlink:href="/static/build/gfx/sprite.svg#icon-gears"></use>
			</svg></i>

			<i class="symbol secondary close xl"></i>
		</button>

		<div class="row adv-option-groups">
			<div id="group-swingtank" class="row justify-content-between fieldgroup">
				<div class="col-5">
					<div class="row no-gutters">
						<div class="col-12 mb-3">
							<h3 class="heading color-grey thin btn-help" data-help="inputs-RLHLmethod">
							Recirculation Loop</h3>
						</div>

						<div class="col-12">
							<div
								:class="{
									'field-wrap': true,
									locked: formData.RLHLmethod === 'Recirculation Loop',
								}"
							>
								<label>Heat Loss</label>

								<div class="row no-gutters field-unit hasChar">
									<input
										type="number"
										:value="formData.RLHLmethod === 'Recirculation Loop' ? '' : formData.Wapt"
										@input="formData.Wapt = $event.target.value"
										step="any"
										min="0.01"
										max="600"
										:disabled="formData.RLHLmethod === 'Recirculation Loop'"
									>

									<i class="icon char">Watts / Apt</i>
								</div>

								<div class="suffix-wrap">
									<p class="desc"></p>

									<p class="locked" v-if="formData.RLHLmethod === 'Recirculation Loop'">
										<i class="symbol help left">
											<object tabindex="-1" type="image/svg+xml" data="/static/build/gfx/svg/symbol-lock.svg"></object>
										</i>Calculated
									by Flow Rate &amp; Return Temperature</p>
								</div>
							</div>
						</div>

						<div class="col-8">
							<div class="field-wrap">
								<label>
									Temperature Maintenance
									<br>
									System Safety Factor
								</label>

								<input
									type="number"
									v-model="formData.TMSafetyFactor"
									step="any"
									min="1.0"
									max="10"
								>

								<div class="suffix-wrap">
									<p class="desc"></p>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div id="fields-RLHLmethod" class="col-6">
					<div class="row no-gutters justify-content-between">
						<div class="col-12 mb-3">
							<button
								type="button"
								id="toggle-RLHLmethod"
								ref="RLHLToggleButton"
								@click.prevent="toggleRLHLmethod"
								:class="{
									'js-btn-toggle': true,
									toggled: formData.RLHLmethod === 'Recirculation Loop',
								}"
								:disabled="shouldDisableRLHLToggle"
								style="margin-bottom:3px;"
							>
								<i class="toggle-knob"></i>

								<span class="label">
									Calculate Heat Loss via Flow Rate &amp; Return Temperature
								</span>
							</button>
						</div>

						<div class="col-6">
							<div
								:class="{
									'field-wrap': true,
									locked: formData.RLHLmethod === 'Watts/Apt.',
								}"
							>
								<label for="">Flow Rate</label>

								<div class="row no-gutters field-unit hasChar">
									<input
										type="number"
										v-model="formData.recircFlow"
										step="any"
										min="0.01"
										max="100"
										:disabled="formData.RLHLmethod === 'Watts/Apt.'"
									>

									<i class="icon char">GPM</i>
								</div>

								<div class="suffix-wrap">
									<p class="desc"></p>
								</div>
							</div>
						</div>

						<div class="col-6">
							<div class="field-wrap">
								<label for="">Return Temperature</label>

								<div class="row no-gutters field-unit">
									<input
										type="number"
										v-model="formData.recircTemp"
										min="32"
										max="212"
									>

									<i class="icon"><svg aria-hidden="true">
										<use xlink:href="/static/build/gfx/sprite.svg#symbol-fahrenheit">
										</use>
									</svg></i>
								</div>

								<div class="suffix-wrap">
									<p class="desc"></p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div
				id="group-paralleltank"
				:class="{
					row: true,
					fieldgroup: true,
					closed: formData.schematic !== 'paralleltank'
				}"
			>
				<div class="col">
					<div class="field-wrap">
						<label>Temperature Maintenance Turn&nbsp;On</label>

						<div class="row no-gutters field-unit">
							<input
								type="number"
								v-model="formData.TMonTemp"
								step="any"
								min="115"
								max="212"
							>

							<i class="icon">
								<svg aria-hidden="true">
									<use xlink:href="/static/build/gfx/sprite.svg#symbol-fahrenheit">
									</use>
								</svg>
							</i>
						</div>

						<div class="suffix-wrap">
							<p class="desc"></p>
						</div>
					</div>
				</div>

				<div class="col offset-1">
					<div class="field-wrap">
						<label>Temperature Maintenance Setpoint</label>

						<div class="row no-gutters field-unit">
							<input
								type="number"
								v-model="formData.setpointTM"
								step="any"
								min="115"
								max="212"
							>

							<i class="icon">
								<svg aria-hidden="true">
									<use xlink:href="/static/build/gfx/sprite.svg#symbol-fahrenheit">
									</use>
								</svg>
							</i>
						</div>

						<div class="suffix-wrap">
							<p class="desc"></p>
						</div>
					</div>
				</div>

				<div class="col offset-1">
					<div class="field-wrap">
						<label>
							One Cycle
							<br/>
							Off Time
						</label>

						<div class="row no-gutters field-unit hasChar">
							<input
								type="number"
								v-model="formData.offTime"
								step="any"
								min="0.01"
								max="23"
							>

							<i class="icon char">Hours</i>
						</div>

						<div class="suffix-wrap">
							<p class="desc"></p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import formData from '@/components/Sizer/form-data-store'

export default {
	name: 'AdvancedOpts',

	data: () => ({
		formData,
		userToggledAdvancedOpts: undefined,
	}),

	computed: {
		expandAdvancedOpts () {
			const { userToggledAdvancedOpts } = this

			return typeof userToggledAdvancedOpts === 'boolean' ?
				userToggledAdvancedOpts :
				formData.errors
		},

		shouldDisableRLHLToggle () {
			return formData.buildingType !== 'multi_family' || formData.customLoadMethod !== 'ignCL'
		},
	},

	watch: {
		'formData.errors' (newVal) {
			// Force panel open when there's a recircFlow error
			if (newVal === true) {
				this.userToggledAdvancedOpts = true
			}
		},

		'formData.customLoadMethod' (newVal) {
			// Force Recirculation Loop when custom load is enabled
			if (newVal !== 'ignCL') {
				this.formData.RLHLmethod = 'Recirculation Loop'
				this.userToggledAdvancedOpts = true
			}
		},

		'formData.buildingType' (newVal) {
			// Force Recirculation Loop and open panel for non-multifamily
			if (newVal !== 'multi_family') {
				this.formData.RLHLmethod = 'Recirculation Loop'
				this.userToggledAdvancedOpts = true
			}
		}
	},

	methods: {
		toggleRLHLmethod () {
			// Force Recirculation Loop for non-multifamily or when custom load is enabled
			if (this.formData.buildingType !== 'multi_family' || this.formData.customLoadMethod !== 'ignCL') {
				this.formData.RLHLmethod = 'Recirculation Loop';
				return;
			}
			const { $refs: { RLHLToggleButton } } = this

			formData.RLHLmethod = formData.RLHLmethod === 'Watts/Apt.'
			? 'Recirculation Loop'
			: 'Watts/Apt.'

			RLHLToggleButton.blur()
		}
	}
}
</script>
